<template>
  <div>
    <router-view v-wechat-title="$route.meta.title" />
  </div>
</template>

<script>

export default {
  name: "App",
};
</script>
<style>
body{
  margin: 0;
  padding: 0;
}
</style>
 